import { PlusCircleFilled } from '@ant-design/icons';
import { Button, Checkbox, Divider, List } from 'antd';
import InspectionAQL from 'app/components/Form/Controlled/AQL';
import Panel from 'app/components/Layout/Panel';
import { ProductListItem } from 'app/components/List';
import {
  filterOutItems,
  filterOutNewlySelectedItems
} from 'app/pages/BookInspection/util';
import ModalSelectProduct from 'app/pages/TemplateManagment/components/ModalSelectProduct';
import { Field, FieldArray } from 'formik';
import { Fragment, useState } from 'react';
import { updateFieldValue } from './util';
import { get } from 'lodash';
import SubPO from 'app/components/Form/Controlled/SubPO';
import classes from './Style.module.scss';

export default function Edit() {
  const [open, setOpen] = useState(false);

  const handleSelectProduct = (field, inspectionAQL) => (selectedProducts) => {
    const { value = [] } = field;
    const existedValue = filterOutItems(value, selectedProducts);
    const newSelectedProducts = filterOutNewlySelectedItems(
      existedValue,
      selectedProducts
    );
    const updatedValue = updateFieldValue(
      existedValue,
      newSelectedProducts,
      inspectionAQL
    );

    field.onChange({
      target: {
        name: field.name,
        value: updatedValue
      }
    });

    setOpen(false);
  };

  return (
    <Panel className={classes.edit}>
      <Field name="inspectionPOItems">
        {({ field, form }) => {
          return (
            <FieldArray name="inspectionPOItems">
              {(helper) => {
                return (
                  <Fragment>
                    <List
                      className={classes.list}
                      dataSource={field.value}
                      split={false}
                      renderItem={(record: any, index) => {
                        return (
                          <ProductListItem
                            bordered
                            className={classes.item}
                            image={record.image}
                            name={record.name}
                            itemNo={record.itemNo || 'N/A'}
                            supplier={record.supplierName || 'N/A'}
                            factory={record.factoryName || 'No Factory Linkage'}
                            extra={
                              <Button
                                ghost
                                danger
                                onClick={() => {
                                  helper.remove(index);
                                }}
                              >
                                Remove
                              </Button>
                            }
                          >
                            <Divider className={classes.dividerMD} />
                            <Field
                              name={`${field.name}[${index}].isSignSample`}
                            >
                              {({ field: checkBoxField }) => {
                                return (
                                  <Checkbox
                                    checked={checkBoxField.value}
                                    onChange={(event) => {
                                      checkBoxField.onChange({
                                        target: {
                                          name: checkBoxField.name,
                                          value: event.target.checked
                                        }
                                      });
                                    }}
                                  >
                                    Signed Sample Available
                                  </Checkbox>
                                );
                              }}
                            </Field>
                            <InspectionAQL
                              fieldNames={{
                                critical: `${field.name}[${index}].inspectionAQL.criticalLevel`,
                                minor: `${field.name}[${index}].inspectionAQL.criticalMinorLevel`,
                                major: `${field.name}[${index}].inspectionAQL.criticalMajorLevel`
                              }}
                            />
                            <SubPO
                              name={`${field.name}[${index}].inspectionSubPOItems`}
                            />
                          </ProductListItem>
                        );
                      }}
                      footer={
                        <Button
                          icon={<PlusCircleFilled />}
                          type="link"
                          onClick={() => {
                            setOpen(true);
                          }}
                        >
                          Add Product
                        </Button>
                      }
                    ></List>
                    <ModalSelectProduct
                      open={open}
                      onCancel={() => {
                        setOpen(false);
                      }}
                      onOk={handleSelectProduct(field, {
                        criticalLevel: get(
                          form.values.inspectionRequirement || {},
                          'criticalLevel'
                        ),
                        criticalMajorLevel: get(
                          form.values.inspectionRequirement || {},
                          'criticalMajorLevel'
                        ),
                        criticalMinorLevel: get(
                          form.values.inspectionRequirement || {},
                          'criticalMinorLevel'
                        )
                      })}
                      selectedValue={field.value}
                    ></ModalSelectProduct>
                  </Fragment>
                );
              }}
            </FieldArray>
          );
        }}
      </Field>
    </Panel>
  );
}
